module.exports = __webpack_public_path__ + "static/media/item_5_13_comp.c6411300.png";